/**
 * There is currently a bug in the viu-schema-data library that
 * will cause a new schema-type to not be returned by the server
 * until a new attribution is saved using an existing schema type.
 * To bypass this, additionally add the new schema type to this array.
 * Schema types returned from the server will be prioritized over this
 * list, matching on schema_type and schema_type_version.
 * This issue may have been bypassed by the work in VIU3-7668
 * 
 * BUG RESOLVED
 */

const SCHEMA_TYPES_FALLBACK: Record<string, any>[] = [];

export function getSchemaTypesWithFallback(schemaTypes: Record<string, any>[]) {
    let mergedSchemaTypes = schemaTypes.reduce((acc, cur) => {
        if (!acc[`${cur.schema_type}_${cur.schema_type_version}`]) {
            acc[`${cur.schema_type}_${cur.schema_type_version}`] = cur;
        }
        return acc;
    }, {} as Record<string, any>);
    mergedSchemaTypes = Object.values(SCHEMA_TYPES_FALLBACK.reduce((acc, cur) => {
        if (!acc[`${cur.schema_type}_${cur.schema_type_version}`]) {
            acc[`${cur.schema_type}_${cur.schema_type_version}`] = cur;
        }
        return acc;
    }, mergedSchemaTypes as Record<string, any>));
    console.log('Merged Json Schema Types', mergedSchemaTypes);
    return mergedSchemaTypes;
}
